import { render } from "./CheckboxInput.vue?vue&type=template&id=19827a32&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=19827a32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19827a32"]])

export default __exports__